import { render, staticRenderFns } from "./kfpackage_total_report.vue?vue&type=template&id=47f6f922&scoped=true"
import script from "./kfpackage_total_report.vue?vue&type=script&lang=js"
export * from "./kfpackage_total_report.vue?vue&type=script&lang=js"
import style0 from "./kfpackage_total_report.vue?vue&type=style&index=0&id=47f6f922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6f922",
  null
  
)

export default component.exports